module.exports = __webpack_public_path__ + "33404662aaee123d14f20b01973d743e.wav";